import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import {reducer as bidReducer } from './Reducers/bidReducer';
import { reducer as auctionReducer } from './Reducers/auctionReducer';
import { reducer as userReducer } from './Reducers/UserReducer';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

const rootReducer = combineReducers({
    auction: auctionReducer,
    bid: bidReducer,
    user: userReducer,
})
const store = createStore(rootReducer, applyMiddleware(thunk, logger));

ReactDOM.render(
<Provider store={store}>
    <Router>
        <App />
    </Router>
</Provider>, 
document.getElementById('root'));

